module.exports = __webpack_public_path__ + "img/poland.2f6422e.webp";